import { getCurrentInstance, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';

export default function(props) {
  const instance = getCurrentInstance().proxy; // 获取当前组件实例
  // 变量
  const personalShow = ref(false); // 是否显示个人中心弹框
  const downloadShow = ref(false); // 是否显示下载弹框
  const downloadList = ref([]); // 下载列表（文件）
  const mediaDownList = ref([]); // 下载列表（视频）
  const downloadShowChanged = ref(false); // 下载弹框显示状态变化

  const leftTimeMap = {}; // 下载任务剩余时间信息
  let downloadInfoSubscribe = null; // 下载消息订阅
  let downloadCompleteSubscribe = null; // 下载完成消息订阅

  let mediaService = []; // 下载视频的socket链接列表
  let mediaDB = null; // WebSQL数据库

  // 监听下载视频消息
  if (props.customize.enableMediaDownload) {
    instance.$onMessage(
      instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD,
      (msg) => {
        if (!instance.$util.isWindowMap()) {
          console.log('EVENT_BUS_CODE_MEDIA_DOWNLOAD onMessage>>>', msg);
          // 主屏操作
          // 默认是用户发来的下载消息
          if (!msg.action) {
            lookDownload();
            videoDown(msg.message, msg.isReload || false, true).then(() => {
              // 通知地图屏加载消息
              let vedio = downloadList.value.find((item) => item.fileType === 'media' && item.id === msg.message.id);
              instance.$postMessage(instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD, {
                action: 'addVedio-map',
                message: vedio
              });
            });
          }
          // 地图屏请求主屏删除操作
          if (msg.action === 'removeVedio-main' && msg.item) {
            console.log('useDownload --- removeVedio-main ----');
            deleteMediaDownloadList(msg.item, true);
          }
        } else {
          console.log('EVENT_BUS_CODE_MEDIA_DOWNLOAD onMessage>>>', msg);
          // 地图屏操作
          // 接受主屏添加的下载记录
          if (msg.action === 'addVedio-map') {
            lookDownload();
            videoDown(msg.message, true, false);
          }
          // 主屏删除同步地图屏
          if (msg.action === 'removeVedio-map') {
            console.log('useDownload --- removeVedio-map ----');
            deleteMediaDownloadList(msg.item, true);
          }
          // 主屏下载进度同步地图屏
          if (msg.action === 'syncVedioProgress-map') {
            syncVedioProgress(msg.message);
          }
        }
      },
      instance
    );
  }

  // 生命周期勾子
  onMounted(() => {
    document.addEventListener('click', handleClick);

    // 满足条件初始化
    if (props.customize.enableMediaDownload && window.KMedia) {
      mediaDB = instance.$util.newMediaSql();
      mediaDB.init().then(loadMediaList);
    }
  });

  onBeforeUnmount(() => {
    // 必须要取消订阅，否则每次路由跳转跳转会重复订阅同一个主题
    if (downloadInfoSubscribe) {
      downloadInfoSubscribe.unsubscribe();
    }
    if (downloadCompleteSubscribe) {
      downloadCompleteSubscribe.unsubscribe();
    }
    document.removeEventListener('click', handleClick);

    // 清理正在下载的ws链接
    mediaService.forEach((mediaServ) => {
      mediaServ.ws.dispose();
      mediaServ.ws = null;
    });
    mediaService = [];
  });

  // Methods
  function handleClick(e) {
    // console.log('PersonCenter handleClick>>>>>>>>>>>>', e);
    // e.stopPropagation();
    if (!downloadShowChanged.value) {
      downloadShow.value = false;
      personalShow.value = false;
    }
    downloadShowChanged.value = false;
  }

  // 查询已经下载列表
  const loadMediaList = () => {
    return new Promise((resolve, reject) => {
      mediaDB
        .findByState()
        .then((res) => {
          console.log('videoDown downloadList >> ', res && res.rows);
          let currentUserName = instance.$auth.getUserInfo().username; // 获取当前用户名
          for (let i = 0, len = res.rows.length; i < len; i++) {
            let obj = res.rows[i];
            console.log('videoDown obj', obj);
            // state: 0 - 下载未完成；1 - 下载已完成
            if (!instance.$util.isWindowMap() && currentUserName === obj.user && obj.state === '0') {
              // 非地图屏下，属于当前用户的下载任务且未完成
              // 非地图屏需要执行下载
              instance.$postMessage(instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD, {
                message: obj,
                isReload: true
              });
            }
          }
          resolve();
        })
        .catch(instance.$message.error);
    });
  };

  // 监听 websocket 消息--下载信息，在 websocketOnmsg 方法中被调用
  const websocketOnmsgDownload = (stompClient, username) => {
    if (!props.customize.disableDownloadLog && !props.customize.hideDownload) {
      downloadInfoSubscribe = stompClient.subscribe(`/user/${username}/downloadInfo`, (data) => {
        try {
          let msg = JSON.parse(data.body);
          console.info('kiaf downloadInfo>>>', msg);
          if (msg && Array.isArray(msg.result)) {
            msg.result.forEach((item) => {
              let found = false;
              // 如果当前下载任务的开始信息不在 leftTimeMap 中，添加一个对应的空对象
              if (!leftTimeMap[item.taskId]) {
                leftTimeMap[item.taskId] = {};
              }

              // 在 downloadList 中查找是否存在对应的下载信息（对比 taskId）
              for (let i = 0; i < downloadList.value.length; i++) {
                let prevItem = downloadList.value[i];
                // downloadList 中存在对应的信息，进行更新
                if (item.taskId && prevItem.taskId === item.taskId) {
                  for (let key in item) {
                    prevItem[key] = item[key];
                  }
                  // 更新标记
                  found = true;
                }
              }
              let percentNum = item.percentage.toString().split('%')[0]; // 获取当前进度
              if (!isNaN(percentNum)) {
                percentNum = Number(percentNum);
                if (!found && item.taskId && percentNum > 0) {
                  // 若 item 不存在于 downloadList 中，将其添加
                  downloadList.value.unshift(item);
                  lookDownload(); // 显示下载进度组件
                }
                // 遍历 downloadList，找出当前 item 对应的数据，计算当前 item 的剩余时间，并更新信息
                for (let i = 0; i < downloadList.value.length; i++) {
                  let prevItem = downloadList.value[i];
                  if (item.taskId && prevItem.taskId === item.taskId) {
                    // leftTimeMap 中没有对应的 startTime 时，表示是新的任务
                    // 设置它的 startTime、lastTime
                    if (!leftTimeMap[item.taskId].startTime) {
                      // 记录开始时间（优先使用返回数据中的 beginTime）
                      if (item.beginTime && !!new Date(item.beginTime)) {
                        leftTimeMap[item.taskId].startTime = new Date(item.beginTime).getTime();

                        // 计算剩余时间（进度大于0 且 当前时间大于开始时间）
                        let now = Date.now();
                        if (percentNum > 0 && now > leftTimeMap[item.taskId].startTime) {
                          let leftTime =
                            (100 - percentNum) / (percentNum / ((now - leftTimeMap[item.taskId].startTime) / 1000));
                          console.log('leftTime --------- ', leftTime);
                          let hh = parseInt(leftTime / 3600);
                          let mm = parseInt((leftTime - hh * 3600) / 60);
                          let ss = Math.ceil(leftTime - hh * 3600 - mm * 60);
                          let leftTimeFormat =
                            Math.ceil(leftTime) > 0
                              ? '剩余: ' + (hh > 0 ? hh + '小时' : '') + (mm > 0 ? mm + '分钟' : '') + ss + '秒'
                              : '';

                          prevItem.percentage = Number(percentNum);
                          prevItem.statusDesc = leftTimeFormat;
                        }
                      } else {
                        // beginTime 不存在时，获取当前时间做为 startTime
                        leftTimeMap[item.taskId].startTime = new Date().getTime();
                      }
                      leftTimeMap[item.taskId].lastTime = new Date().getTime();
                      break;
                    }
                    // 进度已经完成 或 status 已经变成 Y 的，修改状态，本次循环跳过
                    // downloadInfo 消息中，会存在 percentage 不为 100，但 status 已经变为 Y 的情况
                    if (item.status === 'Y' || percentNum >= 100) {
                      // console.log(`kiaf downloadInfo>>> ------- percentage = ${percentNum}`, prevItem);
                      percentNum = 100;
                      leftTimeMap[item.taskId].percentageCompleted = true;
                      // 更新 downloadList 中对应的信息
                      prevItem.percentage = Number(percentNum);
                      prevItem.statusDesc = '';
                      prevItem.status = 'Y';
                      break;
                    } else if (new Date().getTime() - leftTimeMap[item.taskId].lastTime < 2000) {
                      //防止倒计时频繁抖动
                      console.log('kiaf downloadInfo>>>防止倒计时频繁抖动 -------- ', leftTimeMap[item.taskId]);
                      break;
                    }

                    // 计算剩余时间
                    // console.log('leftTimeFormat --------- start', percentNum);
                    let now = Date.now();
                    if (percentNum > 0 && now > leftTimeMap[item.taskId].startTime) {
                      leftTimeMap[item.taskId].lastTime = new Date().getTime();
                      let leftTime =
                        (100 - percentNum) / (percentNum / ((now - leftTimeMap[item.taskId].startTime) / 1000));
                      let hh = parseInt(leftTime / 3600);
                      let mm = parseInt((leftTime - hh * 3600) / 60);
                      let ss = Math.ceil(leftTime - hh * 3600 - mm * 60);
                      let leftTimeFormat =
                        Math.ceil(leftTime) > 0
                          ? '剩余: ' + (hh > 0 ? hh + '小时' : '') + (mm > 0 ? mm + '分钟' : '') + ss + '秒'
                          : '';
                      console.log('kiaf downloadInfo>>>leftTimeFormat --------- ', leftTimeFormat);
                      // 更新 downloadList 中的数据
                      prevItem.percentage = Number(percentNum);
                      prevItem.statusDesc = leftTimeFormat;
                    }
                  }
                }
              }
            });
          }
          // downloadList.value = msg.result;
        } catch (e) {
          console.error('kiaf downloadInfo>>>', e);
        }
      });
      // 此处只用于下载
      downloadCompleteSubscribe = stompClient.subscribe(`/user/${username}/downloadComplete`, (data) => {
        let downloadInfo = JSON.parse(data.body).result;
        console.info('kiaf downloadComplete>>>', downloadInfo);
        let found = false;
        // 在 downloadList 列表中查找对应的下载信息 并更新对应的数据
        for (let i = 0; i < downloadList.value.length; i++) {
          let prevItem = downloadList.value[i];
          if (downloadInfo.taskId && prevItem.taskId === downloadInfo.taskId) {
            for (let key in downloadInfo) {
              prevItem[key] = downloadInfo[key];
            }
            prevItem.statusDesc = ''; // 清除剩余时间信息
            found = true;
            leftTimeMap[downloadInfo.taskId].downloadCompleted = true;
          }
        }

        // 返回的下载任务不在downloadList中 且 downloadInfo中有taskId，添加该数据
        if (!found && downloadInfo.taskId) {
          downloadList.value.unshift(downloadInfo);
        }
        let result = instance.$util.isFileDownloadedBefore(downloadInfo);
        if (!result) {
          console.log(
            'kiaf downladCompleted>>>',
            downloadInfo.downloadUrl && downloadInfo.downloadStatus == 'READY' && !instance.$util.isWindowMap()
          );
          if (downloadInfo.downloadUrl && downloadInfo.downloadStatus == 'READY' && !instance.$util.isWindowMap()) {
            let config = {
              fileName: downloadInfo.zipFileName
            };
            instance.$util.downloadFile(downloadInfo.downloadUrl, config);
          }
          instance.$util.addDownloadedFiles(downloadInfo);
        }
      });
    }
  };

  // 显示下载弹框
  const lookDownload = () => {
    // console.log('下载');
    personalShow.value = false;
    downloadShow.value = true;
    instance.$nextTick(triggerResize);
  };

  // 关闭下载弹框
  const closeDownload = () => {
    downloadShow.value = false;
  };

  // 触发 resize
  const triggerResize = () => {
    // 手动触发一下页面resize事件 用途：popper弹框重新定位
    if (document.createEvent) {
      var event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, true);
      window.dispatchEvent(event);
    } else if (document.createEventObject) {
      window.fireEvent('onresize');
    }
  };

  // 视频下载
  async function videoDown(params, isReload, needDownloadAction) {
    console.log('videoDown params', params);
    if (!window.KMedia) {
      return;
    }
    if (!isReload) {
      // 新的下载任务
      try {
        let msg = await mediaDB.add({ state: 0, ...params }); // 添加下载信息到本地数据库
        instance.$message.success(msg);
        let targetIndex = downloadList.value.findIndex(item => item.id == params.id);
        // 将下载信息添加到 downloadList 中
        targetIndex < 0 && downloadList.value.unshift({
          percentage: '0',
          fileType: 'media',
          ...params
        });
      } catch (err) {
        instance.$message.error(err);
      }
    } else {
      // 恢复下载任务，只需要向 downloadList 中添加
      let targetIndex = downloadList.value.findIndex(item => item.id == params.id);
      // 将下载信息添加到 downloadList 中
      targetIndex < 0 && downloadList.value.unshift({
        percentage: '0',
        fileType: 'media',
        ...params
      });
    }
    if (!needDownloadAction) {
      // 如果不需要执行真正的下载，直接返回（地图屏只显示，不执行真正的下载）
      return;
    }

    // 创建新的 socket 链接
    let newmediaService = new window.KMedia.DataApi.MediaService({
      websocketUrl: params.path
    });
    console.log('videoDown 新server', newmediaService);
    mediaService.push({ id: params.id, ws: newmediaService });
    let sendDate = Object.assign({}, params);
    delete sendDate.id;
    delete sendDate.gbId;
    delete sendDate.name;
    delete sendDate.path;
    delete sendDate.state;
    delete sendDate.user;
    sendDate.fileEncrypt = sendDate.fileEncrypt || '';
    sendDate.speed = sendDate.speed - 0;
    if (instance.$global.getCustomConfig()['KIAF_MEDIA_SPEED']) {
      sendDate.speed = instance.$global.getCustomConfig()['KIAF_MEDIA_SPEED'];
    }
    sendDate.nmediaId = sendDate.nmediaId || 0;
    if (params.waterMark) {
      sendDate.waterMark = Object.assign(
        {
          font_size: 36,
          font_color: '#FFFF00',
          opacity: 0.44, // 不透明度 范围：0~1 0：完全透明， 1：不透明
          rotate_angle: 350, // 旋转角度,范围 0-360
          tile_width: 0.5, // 平铺区域的宽度,（为 0 时不平铺) ,归一值：0-1
          tile_height: 0.5, // 平铺区域的高度
          // 平铺属性生效时只解析第一组 pos_x/pos_y
          text_info: []
        },
        params.waterMark
      );
    }
    // 向 leftTimeMap 中添加信息，后续用来处理剩余下载时间
    if (!leftTimeMap[params.id]) {
      leftTimeMap[params.id] = {};
    }

    // 下载进度回调
    sendDate.progressCallback = (res) => {
      console.log('下载进度', res);
      let percentNum = res.toString().split('%')[0];
      if (!leftTimeMap[params.id].startTime) {
        leftTimeMap[params.id].startTime = new Date().getTime();
        return;
      }
      if (percentNum >= 100) {
        // 标记为已完成
        leftTimeMap[params.id].percentageCompleted = true;
        if (leftTimeMap[params.id].downloadCompleted && mediaServ && mediaServ.ws) {
          mediaServ.ws.dispose();
          mediaServ.ws = null;
        }
        if (leftTimeMap[params.id].url) {
          //初次下载失败，在进度100时再下载一次
          instance.$util.downloadFile(leftTimeMap[params.id].url, { fileName: params.name }, (state, error) => {
            console.error('下载 retry', leftTimeMap[params.id].url);
          });
        }
      }
      let leftTime =
        (100 - percentNum) / (percentNum / ((new Date().getTime() - leftTimeMap[params.id].startTime) / 1000));
      let hh = parseInt(leftTime / 3600);
      let mm = parseInt((leftTime - hh * 3600) / 60);
      let ss = parseInt(leftTime - hh * 3600 - mm * 60);
      let leftTimeFormat =
        parseInt(leftTime) > 0 ? '剩余: ' + (hh > 0 ? hh + '小时' : '') + (mm > 0 ? mm + '分钟' : '') + ss + '秒' : '';

      // 更新下载进度
      if (
        syncVedioProgress({
          mediaId: params.id,
          percentage: res,
          leftTimeFormat
        })
      ) {
        // 同步下载进度到map屏
        instance.$postMessage(instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD, {
          action: 'syncVedioProgress-map',
          message: { mediaId: params.id, percentage: res, leftTimeFormat }
        });
      }
    };
    console.log('videoDown sendDate', sendDate);
    let mediaServ = mediaService.find((media) => media.id == params.id);
    if (mediaServ) {
      mediaServ.ws
        .mediaDownload(sendDate)
        .then((url) => {
          instance.$util.downloadFile(url, { fileName: params.name, id: params.id }, (state, error) => {
            console.log('下载链接', url);
            leftTimeMap[params.id].downloadCompleted = true;
            if (leftTimeMap[params.id].percentageCompleted && mediaServ.ws) {
              mediaServ.ws.dispose();
              mediaServ.ws = null;
            }
            if (error) {
              if (leftTimeMap[params.id].percentageCompleted) {
                // 进度已经完成，只能自己再下载一遍
                instance.$util.downloadFile(url, { fileName: params.name }, (state, error) => {
                  console.error('下载 retry2', url);
                });
              }
              leftTimeMap[params.id].url = url;
            }
          });
        })
        .catch((err) => {
          console.error('mediaDownload ---- catch --- ', err);
          // 下载发生错误
          switch (err.error) {
            case 30010: {
              // request record stream failed:
              instance.$alert('视频下载失败', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  // 删除下载任务，只在业务屏处理
                  if (!instance.$util.isWindowMap()) {
                    this.deleteMediaDownloadList(params, false);
                  }
                }
              });
              break;
            }
            default:
              break;
          }
        });
    }
  }
  function syncVedioProgress({ mediaId, percentage, leftTimeFormat }) {
    let vedioItemIndex = downloadList.value.findIndex((item) => item.fileType === 'media' && item.id === mediaId);
    if (vedioItemIndex > -1) {
      downloadList.value[vedioItemIndex].percentage = Number(percentage.replace('%', ''));
      downloadList.value[vedioItemIndex].statusDesc = leftTimeFormat;
      if (downloadList.value[vedioItemIndex].percentage >= 100) {
        downloadList.value[vedioItemIndex].status = 'Y';
        // 下载成功更新数据库
        mediaDB.updateState(downloadList.value[vedioItemIndex].id);
      }
      return true;
    }
    return false;
  }

  // 删除当前下载列表（视频）
  async function deleteMediaDownloadList(item, isMessage) {
    instance.$util.cancelDownloadFile(item.id);
    if (instance.$util.isWindowMap()) {
      // 如果是地图屏 自己清理呈现列表 并发消息到主屏删
      for (let i = 0, len = downloadList.value.length; i < len; i++) {
        if (downloadList.value[i].fileType == 'media' && downloadList.value[i].id === item.id) {
          downloadList.value.splice(i, 1);
          break;
        }
      }
      !isMessage &&
        instance.$postMessage(
          instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD,
          Object.assign({ action: 'removeVedio-main', item })
        );
      // if (!isMessage) {
      //   console.log('useDownload --- map to main - delete ---');
      //   instance.$postMessage(
      //     instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD,
      //     Object.assign({ action: 'removeVedio-main', item })
      //   );
      // }
      return;
    }

    // 后续为主屏操作
    let arr = mediaService.filter((media) => media.id == item.id);
    if (item.state === '0' && arr.length >= 1 && arr[0].ws) {
      // 正在下载则通知后台停止准备工作
      arr[0].ws.cancelMediaDownload();
      arr[0].ws.dispose();
      arr[0].ws = null;
    }

    try {
      let res = await mediaDB.deleteById(item.id);
      for (let i = 0, len = downloadList.value.length; i < len; i++) {
        if (downloadList.value[i].fileType == 'media' && downloadList.value[i].id === item.id) {
          downloadList.value.splice(i, 1);
          break;
        }
      }
      instance.$message.success(res);

      // 通知地图屏删除记录
      !isMessage &&
        instance.$postMessage(
          instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD,
          Object.assign({ action: 'removeVedio-map', item })
        );
      // if (!isMessage) {
      //   console.log('useDownload --- main to map - delete ---');
      //   instance.$postMessage(
      //     instance.$constants.EVENT_BUS_CODE_MEDIA_DOWNLOAD,
      //     Object.assign({ action: 'removeVedio-map', item })
      //   );
      // }
    } catch (err) {
      instance.$message.error(err);
    }
  }

  //删除当前下载（文件）
  function deleteDownloadList(item) {
    for (let i = 0, len = downloadList.value.length; i < len; i++) {
      if (downloadList.value[i].id === item.id) {
        downloadList.value.splice(i, 1);
        if (props.customize.handelCancelDownload && typeof props.customize.handelCancelDownload === 'function') {
          props.customize.handelCancelDownload(item);
        }
        break;
      }
    }
  }

  return {
    personalShow,
    downloadShow,
    downloadList,
    mediaDownList,
    downloadShowChanged,
    websocketOnmsgDownload,
    lookDownload,
    closeDownload,
    triggerResize,
    loadMediaList,
    videoDown,
    syncVedioProgress,
    deleteMediaDownloadList,
    deleteDownloadList
  };
}
